<template>
  <hm-content title="">
    <div class="table-panel">
      <el-button type="primary" size="small" plain @click="add"
        >新建发送规则
      </el-button>
    </div>
    <div class="table">
      <el-table
        :data="list"
        style="width: 100%"
        stripe
        size="small"
        border
        ref="table"
      >
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="序号"
          width="50"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="规则名称"
          prop="ruleName"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="templateType"
          label="发送类型"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.templateType === 'redMoney'">
              红包发放通知
            </div>
            <div v-if="scope.row.templateType === 'rewardUp'">
              红包活动上线
            </div>
            <div v-if="scope.row.templateType === 'rewardDown'">
              红包活动下线
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="sendContentType"
          label="发送内容"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.sendContentType === 'template'">
              消息模板
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="sendTargetType"
          label="发送时间"
          width="400"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.sendTimeType === 'realtime'">
              实时发送
            </div>
            <div v-if="scope.row.sendTimeType === 'cron'">
              定时发送
              <div>送送时间:{{ scope.row.sendTimeList.join(",") }}</div>
            </div>
            <div v-if="scope.row.sendTimeType === 'fixed'">
              间隔发送
              <div>
                {{ scope.row.fixedStartTime }}至{{
                  scope.row.fixedEndTime
                }}每隔{{ scope.row.fixedTimeValue
                }}{{ scope.row.fixedTimeMode === "H" ? "小时" : "分钟" }}发送
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="msgPackageMode"
          label="发送方式"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.msgPackageMode === 'single'">
              单条一次发送
            </div>
            <div v-if="scope.row.msgPackageMode === 'merge'">
              多条合并发送
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="enableState"
          label="状态"
        >
          <template slot-scope="scope">
            <span
              :class="scope.row.enableState === 'yes' ? 'success' : 'danger'"
            >
              {{ scope.row.enableState === "yes" ? "启用" : "禁用" }}</span
            >
          </template>
        </el-table-column>

        <el-table-column
          label="操作"
          header-align="center"
          align="center"
          width="180"
        >
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-button
                type="text"
                size="small"
                :class="scope.row.enableState === 'yes' ? 'danger' : 'success'"
                @click="edit(scope.row)"
              >
                {{ scope.row.enableState === "yes" ? "禁用" : "启用" }}
              </el-button>
              <el-button type="text" size="small" @click="remove(scope.row)">
                删除
              </el-button>
              <el-button type="text" size="small" @click="copy(scope.row)">
                复制
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="total"
        @current-change="paging"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="currentPage"
      ></el-pagination>
    </div>
  </hm-content>
</template>

<script>
import { setCookie } from "@/utils/utils";
export default {
  components: {},
  data() {
    return {
      list: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      searchCondition: {},
      params: {
        templateType: "",
        ruleName: "",
        sendTargetType: "",
        sendContentType: "",
        sendTimeType: "",
        msgPackageMode: "",
        sendTimeList: [],
        applyDate: [],
        fixedTimeValue: "",
        fixedTimeMode: ""
      }
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.queryList();
  },
  methods: {
    async edit(row) {
      let params = JSON.parse(JSON.stringify(row));
      params.enableState = params.enableState === "yes" ? "no" : "yes";
      const { code } = await this.$store.dispatch("editWxMsgSendRule", params);
      if (code === "0") {
        this.$message({
          message: "操作成功",
          type: "success"
        });

        this.queryList();
      }
    },
    copy(row) {
      let data = {
        step1: {},
        step2: {}
      };
      //   setCookie({ key: "MSGRULESTEP", data });
      for (let key in this.params) {
        if (key === "templateType") {
          data.step1[key] = row[key];
        } else if (key === "applyDate") {
          data.step2[key] =
            row.sendTimeType === "fixed"
              ? [row.fixedStartTime, row.fixedEndTime]
              : [];
        } else {
          data.step2[key] = row[key];
        }
      }
      setCookie({ key: "MSGRULESTEP", data });
      this.$router.push({
        name: "SendMsgRule",
        query: {
          type: "sendRule"
        }
      });
      //   this.$router.push({
      //     name: "SendRuleConfig"
      //   });
    },
    remove(row) {
      this.$confirm(" 删除本行数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let params = JSON.parse(JSON.stringify(row));
        params.delFlag = "1";
        this.$store.dispatch("editWxMsgSendRule", params).then(res => {
          if (res.code === "0") {
            this.$message({
              message: " 操作成功",
              type: "success"
            });
            this.queryList();
          }
        });
      });
    },
    async queryList() {
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch(
        "queryWxMsgSendRuleList",
        searchCondition
      );
      this.list = result.records;
      this.total = result.total;
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    add() {
      this.$router.push({
        name: "SendMsgRule",
        query: {
          type: "sendRule"
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped></style>
